module.exports = __webpack_public_path__ + "img/6.1b3ff934.png";